import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { api } from "../../../Requests/Api";
import styles from "./OptinList.module.scss";
import {
    Result,
    Button,
    PageHeader,
    Spin,
    Skeleton,
    Input,
    Divider,
    message,
    notification,
} from "antd";
import LoadMore from "../../LoadMore/LoadMore";
import OptinSelectCustomers from "./OptinSelectCustomers";
import OptinSelectTemplate from "./OptinSelectTemplate";
import SendTemplateModal from "./SendTemplateModal";
const { Search } = Input;
const { optInList, optInList__full } = styles;
function OptinList({ visible, closeCb }) {
    const { t } = useTranslation();
    const [page] = useState(0);
    const [customers, setCustomers] = useState([]);
    const [customersPaginatorHasNext, setCustomersPaginatorHasNext] = useState(false);
    const [customersPaginatorPage, setCustomersPaginatorPage] = useState(0);
    const [selectedCustomers, setSelectedCustomers] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState({});
    const [showTemplate, setShowTemplate] = useState(false);
    const [templates, setTemplates] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [outboundConfig, setOutboundConfig] = useState(null);
    const [serverError, setServerError] = useState(true);
    const [searchInputVal, setSearchInputVal] = useState("");
    const typingTimeoutRef = useRef(null);
    const inputRef = useRef(null);

    function showServerErrorMessage(key) {
        if (
            key === "WHATSAPP_OUTBOUND_LIMIT_EXCEEDED" ||
            key === "INSUFFICIENT_WHATSAPP_OUTBOUND_CREDITS" ||
            key === "WHATSAPP_OUTBOUND_NOT_ENABLED" ||
            key === "CAMPAIGN_MUST_USE_AN_APPROVED_TEMPLATE"
        ) {
            setServerError({ message: t("outboundMessages." + key) });
        } else {
            setServerError({ message: t("error") });
        }
    }

    function addCustomer(customer) {
        setSelectedCustomers(customer);
        setShowTemplate(true);
    }
    function selectTemplate(template) {
        setSelectedTemplate(template);
        setIsModalVisible(true);
    }

    function isOutboundEnabled() {
        return outboundConfig.usage + 1 <= outboundConfig.limit;
    }

    function setDefaults() {
        setIsLoading(false);
        setSelectedTemplate(null);
        setSelectedCustomers(null);
        setIsModalVisible(false);
        setOutboundConfig(null);
        setShowTemplate(false);
    }

    function handleSearchInput(e) {
        setSearchInputVal(e.target.value); 
    }

    function searchCustomer(searchText) {
        setIsLoading(true);
        api.customer()
            .list(page, searchText)
            .then((res) => {
                setServerError(null);
                setCustomers(res.data.customers);
                setIsLoading(false);
                inputRef.current.focus({cursor: 'end'});
            })
            .catch((err) => {
                showServerErrorMessage(err.response?.data?.error?.key);
                setIsLoading(false);
            });
    }

    function changeCustomerPage() {
        setCustomersPaginatorPage((customersPaginatorPage) => customersPaginatorPage + 1);
    }

    const handleOk = () => {
        setIsLoading(true);
        api.outbound()
            .createAndSendCampaign({
                customer_id: selectedCustomers.id,
                template_id: selectedTemplate.id,
            })
            .then((res) => {
                if (!res.data.conversation || !res.data.conversation.id) {
                    throw new Error({ response: { data: { error: t("error") } } });
                }
                setDefaults();
                closeCb();
                notification["success"]({
                    key: "outbound",
                    duration: 6,
                    message: t("outbound.sended"),
                    description: t("outbound.sendedDesc"),
                });
            })
            .catch((err) => {
                message.error(t("error"));
                setDefaults();
                showServerErrorMessage(err.response?.data?.error?.key);
            });
    };

    useEffect(() => {
        if (visible) {
            setCustomersPaginatorPage(0);
            setSearchInputVal("");
            setIsLoading(true);
            api.outbound()
                .getConfigs()
                .then((res) => {
                    setOutboundConfig(res.data);
                    api.customer()
                        .list(page)
                        .then((res) => {
                            setServerError(null);
                            setCustomersPaginatorHasNext(res.data.paginator.hasNext);
                            setCustomers(res.data.customers);
                            setIsLoading(false);
                        })
                        .catch((err) => {
                            showServerErrorMessage(err.response?.data?.error?.key);
                            setIsLoading(false);
                            console.log(err);
                        });
                    api.outbound()
                        .getWhatsappTemplates()
                        .then((res) => {
                            setServerError(null);
                            setTemplates(
                                res.data.templates
                                    .filter((template) => template.status === "APPROVED")
                                    .sort((a, b) => b.id - a.id)
                            );
                        })
                        .catch((err) => {
                            showServerErrorMessage(err.response?.data?.error?.key);
                            console.log(err);
                        });
                })
                .catch((err) => {
                    showServerErrorMessage(err.response?.data?.error?.key);
                    setIsLoading(false);
                });
        }
    }, [visible]);
    useEffect(() => {
        if (customersPaginatorPage) {
            setIsLoading(true);
            api.customer()
                .list(customersPaginatorPage, searchInputVal)
                .then((res) => {
                    setCustomersPaginatorHasNext(res.data.paginator.hasNext);
                    setCustomers((customers) => [...customers, ...res.data.customers]);
                    setServerError(null);
                    setIsLoading(false);
                })
                .catch((err) => {
                    showServerErrorMessage(err.response?.data?.error?.key);
                    setIsLoading(false);
                    console.log(err);
                });
        }
    }, [customersPaginatorPage]);
    useEffect(() => {
        if (searchInputVal) {
            clearTimeout(typingTimeoutRef.current);
            typingTimeoutRef.current = setTimeout(() => {
                searchCustomer(searchInputVal);
            }, [1000]);
        } else {
            searchCustomer("");
        }
    }, [searchInputVal]);
    return (
        <div className={`${optInList} ${visible && optInList__full}`}>
            <PageHeader onBack={() => closeCb()} title="" subTitle={t("newChat")} />
            {isLoading ? (
                <Spin spinning={isLoading}>
                    <div style={{ padding: "0 20px" }}>
                        <Skeleton active />
                    </div>
                </Spin>
            ) : (
                <>
                    {serverError ? (
                        <>
                            <Result
                                status="error"
                                title={""}
                                extra={
                                    <>
                                        <p>{serverError.message}</p>
                                        <Button onClick={() => closeCb()}>{t("back")}</Button>
                                    </>
                                }
                            />
                        </>
                    ) : (
                        <>
                            {outboundConfig && isOutboundEnabled() ? (
                                <>
                                    <div style={{ margin: "0 10px" }}>
                                        <Search
                                            allowClear
                                            ref={inputRef}
                                            placeholder={t("filters.searchClients")}
                                            value={searchInputVal}
                                            onChange={handleSearchInput}
                                        />
                                    </div>
                                    <OptinSelectCustomers
                                        searchInputVal={searchInputVal}
                                        setSearchInputValCb={setSearchInputVal}
                                        closeCb={closeCb}
                                        addCustomerCb={addCustomer}
                                        searchCustomerCb={searchCustomer}
                                        selectedCustomers={selectedCustomers}
                                        customers={customers}
                                    />
                                    {customersPaginatorHasNext && (
                                        <>
                                            <Divider />
                                            <LoadMore
                                                onClick={changeCustomerPage}
                                                style={{ marginTop: "0px", marginBottom: "15px" }}
                                            />
                                        </>
                                    )}
                                </>
                            ) : (
                                <Result
                                    status="warning"
                                    title={t("outbound.noCredits")}
                                    extra={
                                        <>
                                            <p>{t("outbound.noCreditsDesc")}</p>
                                            <Button onClick={() => closeCb()}>{t("back")}</Button>
                                        </>
                                    }
                                />
                            )}
                            {templates.length > 0 ? (
                                <OptinSelectTemplate
                                    templates={templates}
                                    visible={showTemplate}
                                    selectTemplateCb={selectTemplate}
                                    closeCb={() => setShowTemplate(false)}
                                />
                            ) : (
                                <Result
                                    status="warning"
                                    title={t("outbound.noTemplatesTitle")}
                                    extra={
                                        <>
                                            <p>{t("outbound.noTemplates")}</p>
                                            <Button onClick={() => closeCb()}>{t("back")}</Button>
                                        </>
                                    }
                                />
                            )}
                            <SendTemplateModal
                                selectedCustomer={selectedCustomers}
                                selectedTemplate={selectedTemplate}
                                isVisible={isModalVisible}
                                setIsVisible={setIsModalVisible}
                                handleSendTemplate={handleOk}
                            />
                        </>
                    )}
                </>
            )}
        </div>
    );
}
export default OptinList;
